"use client";

import { useNavigate } from "react-router-dom";
import CustomerDetails from "../global/view/customer-detailsForm.jsx";

const RpDebtors = () => {
  const navigate = useNavigate();

  return (
    <CustomerDetails
      backTo="/customer/dispensary/script"
      actionButtonLabel="View"
      onActionClick={(profileNo) => {
        navigate(`/credits/rpdebtors/${profileNo}`);
      }}
    />
  );
};

export default RpDebtors;
